import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import AdminLayout from "@/components/AdminLayout";
import { api } from "@/lib/api";
import { Card, Field, SaveBtn } from "@/components/admin/challenge/ChallengeAdminParts";

const PREVIEW_LINKS = [["Wahl", "/lp/kt400-wahl"], ["Team", "/lp/kt400-team"], ["Privat", "/lp/kt400-privat"], ["Pause", "/lp/kt400-pause"]];
const CHOICE_FIELD_LABELS = { choice_headline: "Überschrift", choice_label_team: "Knopf Team", choice_label_privat: "Knopf Privat", choice_label_pause: "Knopf Pause" };

export default function AdminKT400() {
  const [cfg, setCfg] = useState(null);
  const [form, setForm] = useState({ offer_url: "", cta_label_team: "", cta_label_privat: "", cta_enabled: true, pause_link_enabled: false, pause_link_label: "" });
  const [busy, setBusy] = useState(false);

  const load = async () => {
    const { data } = await api.get("/admin/kt400/config");
    setCfg(data);
    setForm({ offer_url: data.offer_url, cta_label_team: data.cta_label_team, cta_label_privat: data.cta_label_privat, cta_enabled: data.cta_enabled,
      pause_link_enabled: data.pause_link_enabled, pause_link_label: data.pause_link_label,
      ...Object.fromEntries(Object.keys(data.choice_defaults).map((k) => [k, data[k]])) });
  };
  useEffect(() => { load().catch(() => toast.error("Konfiguration konnte nicht geladen werden.")); }, []);

  const save = async () => {
    setBusy(true);
    try {
      await api.put("/admin/kt400/config", form);
      await load();
      toast.success("Gespeichert");
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Speichern fehlgeschlagen");
    } finally {
      setBusy(false);
    }
  };
  const set = (k) => (v) => setForm((f) => ({ ...f, [k]: v }));

  return (
    <AdminLayout>
      <div className="space-y-5 max-w-2xl" data-testid="admin-kt400-page">
        <header>
          <p className="text-xs font-bold uppercase tracking-widest text-[#4563BB]">Admin · KT400</p>
          <h1 className="text-2xl font-bold text-slate-900">Segmentierungsseiten</h1>
          <p className="mt-1 text-sm text-slate-600">Änderungen gelten sofort, ohne Deploy. An den Link werden automatisch utm_campaign=kt400 und utm_content=team bzw. privat angehängt.</p>
        </header>
        {cfg && (
          <Card title="Button" testId="kt400-admin-card">
            <label className="flex items-center gap-3 text-sm">
              <input type="checkbox" checked={form.cta_enabled} onChange={(e) => setForm((f) => ({ ...f, cta_enabled: e.target.checked }))}
                className="w-4 h-4" data-testid="kt400-admin-enabled" />
              Button aktiv (aus = deaktiviert, „Angebot folgt“)
            </label>
            <Field label="Offer-URL (leer = Wert aus der Server-Konfiguration)" value={form.offer_url} onChange={set("offer_url")}
              testId="kt400-admin-offer-url" placeholder={cfg.env_offer_url || "https://…"} />
            <p className="text-xs text-slate-500 break-all" data-testid="kt400-admin-effective-url">
              Aktiv: {cfg.effective_offer_url || "keine gültige URL → Button deaktiviert („Angebot folgt“)"}
            </p>
            <Field label="Button-Text Team" value={form.cta_label_team} onChange={set("cta_label_team")}
              testId="kt400-admin-label-team" placeholder={cfg.default_label} />
            <Field label="Button-Text Privat" value={form.cta_label_privat} onChange={set("cta_label_privat")}
              testId="kt400-admin-label-privat" placeholder={cfg.default_label} />
            <p className="text-xs text-slate-500">Leer = „{cfg.default_label}“. Max. 60 Zeichen.</p>
            <SaveBtn onClick={save} busy={busy} testId="kt400-admin-save" />
          </Card>
        )}
        {cfg && (
          <Card title="Pause-Seite: Link zum Cockpit" testId="kt400-admin-pause-card">
            <label className="flex items-center gap-3 text-sm">
              <input type="checkbox" checked={form.pause_link_enabled} onChange={(e) => setForm((f) => ({ ...f, pause_link_enabled: e.target.checked }))}
                className="w-4 h-4" data-testid="kt400-admin-pause-enabled" />
              Link anzeigen (dezenter Textlink zu /cockpit, hebt die 90-Tage-Pause nicht auf)
            </label>
            <Field label="Linktext" value={form.pause_link_label} onChange={set("pause_link_label")}
              testId="kt400-admin-pause-label" placeholder={cfg.default_pause_label} />
            <SaveBtn onClick={save} busy={busy} testId="kt400-admin-pause-save" />
          </Card>
        )}
        {cfg && (
          <Card title="Präferenzseite (/lp/kt400-wahl)" testId="kt400-admin-choice-card">
            <p className="text-xs text-slate-500 break-all" data-testid="kt400-admin-choice-link-hint">
              Link für die KlickTipp-Mail: https://DEINE-DOMAIN/lp/kt400-wahl#e=%Subscriber:EmailAddress%
            </p>
            {Object.keys(cfg.choice_defaults).map((k) => (
              <Field key={k} label={CHOICE_FIELD_LABELS[k]} value={form[k] || ""} onChange={set(k)}
                testId={`kt400-admin-${k.replace(/_/g, "-")}`} placeholder={cfg.choice_defaults[k]} />
            ))}
            <SaveBtn onClick={save} busy={busy} testId="kt400-admin-choice-save" />
          </Card>
        )}
        <div className="flex gap-4 text-sm" data-testid="kt400-admin-preview-links">
          {PREVIEW_LINKS.map(([l, p]) => (
            <a key={p} href={p} target="_blank" rel="noreferrer" className="text-[#4563BB] underline" data-testid={`kt400-admin-open-${l.toLowerCase()}`}>{l} öffnen</a>
          ))}
        </div>
      </div>
    </AdminLayout>
  );
}
